import { Construction } from 'lucide-react';
import { Container, PageHeader } from '@vnetwork/ui/layout';
import { EmptyState } from '@vnetwork/ui/data';
import { AccountBreadcrumbs } from './components/account-breadcrumbs';

/**
 * My Contracts — stub page. The legacy console shows a "Coming Soon"
 * placeholder for this route; there is no backend for it yet.
 * Mirror: src/pages/account/AccountInfoPage.tsx (shell).
 */
export default function AccountContractsPage() {
  return (
    <Container size="full">
      <PageHeader
        breadcrumbs={<AccountBreadcrumbs current="My Contracts" />}
        title="My Contracts"
        description="Your labor contracts and employment agreements"
      />
      <EmptyState
        icon={<Construction size={24} />}
        title="Coming soon"
        description="Contract management is not available yet."
      />
    </Container>
  );
}
